export const GET_USER_PROFILE_REQUEST = 'GET_USER_PROFILE_REQUEST';
export const GET_USER_PROFILE_SUCCESS = 'GET_USER_PROFILE_SUCCESS';
export const GET_USER_PROFILE_FAILED = 'GET_USER_PROFILE_FAILED';

export const GET_PROFILE_FOLLOWERS_REQUEST = 'GET_PROFILE_FOLLOWERS_REQUEST';
export const GET_PROFILE_FOLLOWERS_SUCCESS = 'GET_PROFILE_FOLLOWERS_SUCCESS';
export const GET_PROFILE_FOLLOWERS_FAILED = 'GET_PROFILE_FOLLOWERS_FAILED';

// TODO: refactor then
export const RESET_CLASSES_SCROLL = 'RESET_CLASSES_SCROLL';

export const CURRENT_PROFILE_STATS = 'CURRENT_PROFILE_STATS';



// WEBPACK FOOTER //
// ./src/Store/ActionTypes/ProfileActionTypes.js